import _defineProperty from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
export var eventCat = 'Modules';
export var eventName = 'eventTracker';
export var eventAct = '';

// convert array of obj to obj:
// {
// 	key: analyticObj
// }
export var convertToAnalyticObject = function convertToAnalyticObject(store) {
  store.forEach(function (analytic) {
    analytic.eventCat = analytic.eventCat && analytic.eventCat !== '' ? analytic.eventCat : eventCat;
    analytic.eventAct = analytic.eventAct && analytic.eventAct !== '' ? analytic.eventAct : eventAct;
    analytic.eventName = analytic.eventName && analytic.eventName !== '' ? analytic.eventName : eventName;
  });
  store = store.reduce(function (obj, item) {
    return Object.assign(obj, _defineProperty({}, item.key, item));
  }, {});
  return store;
};
export var addDefaultValues = function addDefaultValues(analytic) {
  if (analytic) {
    analytic.eventCat = analytic.eventCat ? analytic.eventCat : eventCat;
    analytic.eventName = analytic.eventName ? analytic.eventName : eventName;
  }
  return analytic;
};